import { GetterTree } from "vuex";
import { State } from "./orai";

// TODO: Make Fully typed Getters
export const getters: GetterTree<State, any> = {
  teamLessonScores: (myState) => myState.teamLessonsScores,
  myLessons: (myState) => myState.myLessons,
  learnerRecordings: (myState) => myState.learnerRecordings,
  lessonByID: (myState) => {
    return (ID: Number) =>
      myState.myLessons ? myState.myLessons!.find((x) => x.ID === ID) : null;
  },
  JWT: (myState) => myState.JWT,
  UID: (myState) => myState.UID,
  doneInitAssessment: (myState) => {
    let done = (window as any).$cookies.get("DONE_ONBOARD");
    console.log(Boolean(done), done);
    return done === "true" || myState.doneInitAssessment;
  },
  teams: (myState) => myState.teams,
  teamByID: (myState) => {
    return (ID: Number) => myState.teams!.find((x) => x.ID === ID);
  },
  learnerTeams: (myState) => myState.learnerTeams,
  currentLearnerTeam: (myState) => myState.currentLearnerTeam,
  currentLearnerTeamID: (myState) =>
    myState.currentLearnerTeam ? myState.currentLearnerTeam.id : null,
  learnerTeamByID: (myState) => {
    return (ID: Number) => myState.learnerTeams!.find((x) => x.id === ID);
  },
  currentTeamUsers: (myState) => myState.currentTeamUsers,
  currentTeam: (myState) => myState.currentTeam,
  currentTeamID: (myState) =>
    myState.currentTeam ? myState.currentTeam.ID : null,
  currentTeamStats: (myState) => myState.currentTeamStats,
  currentTeamActivity: (myState) => myState.currentTeamActivity,
  userByID: (myState) => {
    return (UID: string) =>
      myState.currentTeamUsers!.find((x) => x.UID === UID);
  },
  teamLessons: (myState) => myState.teamLessons,
  userMeta: (myState) => myState.userMeta,
  recordedVideoURL: (myState) => myState.recordedVideoURL,
  teamEngagement: (myState) => myState.teamEngagement,
  teamCompletion: (myState) => myState.teamCompletion,
  teamLeaderboard: (myState) => myState.teamLeaderboard,
  teamPerformanceOverall: (myState) => myState.teamPerformanceOverall,
  teamPerformancePace: (myState) => myState.teamPerformancePace,
  teamPerformanceConciseness: (myState) => myState.teamPerformanceConciseness,
  teamPerformanceFillers: (myState) => myState.teamPerformanceFillers,
  userPlan: (myState) => myState.userPlan,
  userLicenseList: (myState) => myState.userLicenseList,
  userPlanLoading: (myState) => myState.userPlanLoading,
  availablePlansLoading: (myState) => myState.availablePlansLoading,
  availablePlans: (myState) => myState.availablePlans,
  proPlan: (myState) =>
    myState.availablePlans
      ? myState.availablePlans.filter((p) => p.id == "2")[0]
      : null,
  sessionReviewRequired: (myState) => myState.sessionReviewRequired,
  sessionAlreadyReviewed: (myState) => myState.sessionAlreadyReviewed,
  transcriptStartIndex: (myState) => myState.transcriptStartIndex,
  transcriptEndIndex: (myState) => myState.transcriptEndIndex,
  reviewCommentSelectedIndex: (myState) => myState.reviewCommentSelectedIndex,
  reviewCommentPlay: (myState) => myState.reviewCommentPlay,
  newReviewCommentVisible: (myState) => myState.newReviewCommentVisible,
  rubricData: (myState) => myState.rubricData,
  rubricSessionAnswers: (myState) => myState.rubricSessionAnswers,
  rubricSessionAverageAnswers: (myState) => myState.rubricSessionAverageAnswers,
  rubricSessionAnswersByUser: (myState) => myState.rubricSessionAnswersByUser,
  teamReviewSettings: (myState) => myState.teamReviewSettings,
  sessionFeedback: (myState) => myState.sessionFeedback,
  learnerReviews: (myState) => myState.learnerReviews,
  displayError: (myState) => myState.displayError,
};
